import type { PayloadAction } from "@reduxjs/toolkit";

import type { IPriceMode } from "./models";

export const UPDATE = "priceMode/update";
export function updatePriceMode(
  payload: IPriceMode,
): PayloadAction<IPriceMode> {
  localStorage.setItem("Verwimp.catalog.price-mode", payload.priceMode);
  document.body.classList.remove("customer-price-mode", "retail-price-mode");
  if (payload.priceMode === "customer") {
    document.body.classList.add("customer-price-mode");
  } else if (payload.priceMode === "retail") {
    document.body.classList.add("retail-price-mode");
  }
  return {
    type: UPDATE,
    payload,
  };
}
